import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';

import HiLoBet from './hiLoBet';
import Timer from '../../../containers/common/timer';
import { marketsStore } from '../../../store/marketsStore';
import CardResult from '../../../containers/common/cardResults';
import GameBetTabs from '../../../containers/common/gameBetTabs';
import { HiLoButtonsBlock, TimerBlock } from '../../../containers/common';
import BetAndRoundStepInfoComp from '../../../containers/common/betAndRoundStepInfo';

const GameSection = observer(() => {
  const { roundId } = roundInfoStore;
  const { replayActiveMainMoreSection } = marketsStore;

  return (
    <>
      <div className='content-t-inner-top'>
        <div className='content-t-inner-top-ins'>
          <div className='mob-game-small-cards-ins'>
            <div className='m-g-small-cards-wrp'>
              <CardResult />
              <div className='con-center-center-ins-cards-back-wrp'>
                <div className='con-center-center-ins-cards-back-item' />
                <div className='con-center-center-ins-cards-back-item' />
                <div className='con-center-center-ins-cards-back-item' />
                <div className='con-center-center-ins-cards-back-item' />
                <TimerBlock innerComp={Timer} key={roundId} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='content-t-inner-center'>
        <div className='content-center-inner'>
          <GameBetTabs mobile={false} replayActiveMainMoreSection={replayActiveMainMoreSection} />

          <div className='content-center-center '>
            <BetAndRoundStepInfoComp />
          </div>
          <HiLoButtonsBlock innerComp={HiLoBet} />
        </div>
      </div>
    </>
  );
});

export default GameSection;
